<template>
    <div> <b-card no-body class="my-2">
            <b-card-header class="">
                <b-card-title class="card-title-page-garden-help-default my-1">Create Quote
                </b-card-title>
            </b-card-header>
        </b-card>

        <b-form @submit.prevent="onSubmit" ref="addJobForm">
            <b-card no-body class="mt-4">
                <b-card-body class="px-2">
                    <b-row>
                        <b-col md="6" class="pr-md-0">
                            <PersonalData :type="perosnal_data_type" :card_title="'Customer Details'"
                                :first_name.sync="first_name" :last_name.sync="last_name" :email.sync="email"
                                :phone_number.sync="phone_number" :contact_through.sync="contact_through"
                                :view_contact_throught="false" />

                            <!-- services -->
                            <b-card no-body class="card-transparent-background my-0">
                                <b-card-header class="card-title-garden-help-default">
                                    Services Details
                                </b-card-header>

                                <b-card-body class="py-0 pr-0">
                                    <div class="" v-if="quote_services.length > 0">
                                        <b-row class="mb-3" v-for="(service, index) in quote_services" :key="index + 1">
                                            <b-col cols=12>
                                                <h3 class="card-subtitle-garden-help-default px-0 mb-0">Service {{ index + 1
                                                }}

                                                    <b-button type="button" variant="action-garden-help" class="float-end"
                                                        v-if="index >= job_services.length"
                                                        @click="clickDeleteService(index)">
                                                        <img src="@/assets/images/garden-help/delete-icon.png" />
                                                    </b-button>
                                                </h3>
                                            </b-col>
                                            <b-col cols="12">
                                                <b-form-group class="form-group-garden-help" label="Service"
                                                    :label-for="'service_id' + (index + 1)"
                                                    label-class="form-label-garden-help">
                                                    <p class="error_validation_message_p_gardenhelp"
                                                        v-if="service.invalid_service">
                                                        Please select service
                                                    </p>
                                                    <span v-if="index < job_services.length"
                                                        class="form-control form-control-garden-help">
                                                        {{ service.service_name }}
                                                    </span>
                                                    <v-select v-else :options="services_list" v-model="service.service_id"
                                                        :name="'service_id' + (index + 1)" placeholder="Select service"
                                                        label="name" :clearable="false" :multiple="false">
                                                    </v-select>

                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12">
                                                <b-form-group class="form-group-garden-help" label="Estimated Price"
                                                    :label-for="'estimated_price' + (index + 1)"
                                                    label-class="form-label-garden-help">
                                                    <p class="error_validation_message_p_gardenhelp"
                                                        v-if="service.invalid_estimated_price">
                                                        Please enter estimated price
                                                    </p>


                                                    <b-input-group :append="currency ? currency : 'EUR'"
                                                        class="input-group-garden-help">
                                                        <b-form-input :id="'estimated_price' + (index + 1)"
                                                            class="form-control-garden-help" type="number" min="0"
                                                            v-model="service.estimated_price" required></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12">
                                                <b-form-group class="form-group-garden-help" label="Description"
                                                    :label-for="'description' + (index + 1)"
                                                    label-class="form-label-garden-help">
                                                    <b-textarea :id="'description' + (index + 1)"
                                                        class="form-control-garden-help" v-model="service.description"
                                                        rows="4"></b-textarea>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-button variant="garden-help-primary-link"
                                                class="btn-bumblebee btn-garden-help" size="lg" @click="clickAddService">
                                                <font-awesome-icon icon="fa-solid fa-circle-plus" size="lg" />
                                                Add another service
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-card-body>
                            </b-card>


                            <!-- end services-->
                        </b-col>
                        <b-col md="6">
                            <!-- items -->
                            <b-card no-body class="card-transparent-background my-0">
                                <b-card-header class="card-title-garden-help-default">
                                    Items
                                </b-card-header>

                                <b-card-body class="py-0 pr-0">
                                    <div class="" v-if="quote_items.length > 0">
                                        <b-row class="mb-3" v-for="(item, index) in quote_items" :key="index + 1">
                                            <b-col cols=12>
                                                <h3 class="card-subtitle-garden-help-default px-0 mb-0">
                                                    Item {{ index + 1 }}
                                                    <b-button type="button" variant="action-garden-help" class="float-end"
                                                        v-if="index > 0" @click="clickDeleteProduct(index)">
                                                        <img src="@/assets/images/garden-help/delete-icon.png" />
                                                    </b-button>
                                                </h3>
                                            </b-col>
                                            <b-col cols="12">
                                                <b-form-group class="form-group-garden-help" label="Item name"
                                                    :label-for="'product_id' + (index + 1)"
                                                    label-class="form-label-garden-help">
                                                    <p class="error_validation_message_p_gardenhelp"
                                                        v-if="item.invalid_name">
                                                        Please enter item name
                                                    </p>
                                                    <!-- <v-select :options="products_list" v-model="item.product_id"
                                                        :name="'product_id' + (index + 1)" placeholder="Select product"
                                                        label="name" :reduce="(item) => item.id" :clearable="false"
                                                        :multiple="false" required>
                                                    </v-select> -->

                                                    <b-form-input :id="'product' + (index + 1)"
                                                        class="form-control-garden-help" v-model="item.name"
                                                        required></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12">
                                                <b-form-group class="form-group-garden-help" label="Description"
                                                    :label-for="'description' + (index + 1)"
                                                    label-class="form-label-garden-help">
                                                    <b-textarea :id="'description' + (index + 1)"
                                                        class="form-control-garden-help" v-model="item.description"
                                                        rows="4"></b-textarea>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12">
                                                <b-form-group class="form-group-garden-help " label="Quantity"
                                                    :label-for="'quantity' + (index + 1)"
                                                    label-class="form-label-garden-help">
                                                    <p class="error_validation_message_p_gardenhelp"
                                                        v-if="item.invalid_quantity">
                                                        Please enter quantity
                                                    </p>
                                                    <b-form-input :id="'quantity' + (index + 1)"
                                                        class="form-control-garden-help" type="number" min="1"
                                                        v-model="item.quantity" required></b-form-input>

                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12">
                                                <b-form-group class="form-group-garden-help " label="Price"
                                                    :label-for="'price' + (index + 1)" label-class="form-label-garden-help">
                                                    <p class="error_validation_message_p_gardenhelp"
                                                        v-if="item.invalid_price">
                                                        Please enter price
                                                    </p>

                                                    <b-input-group :append="currency ? currency : 'EUR'"
                                                        class="input-group-garden-help">

                                                        <b-form-input :id="'price' + (index + 1)"
                                                            class="form-control-garden-help" type="number" min="0"
                                                            v-model="item.price" required></b-form-input>
                                                    </b-input-group>

                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-button variant="garden-help-primary-link"
                                                class="btn-bumblebee btn-garden-help" size="lg" @click="clickAddProduct">
                                                <font-awesome-icon icon="fa-solid fa-circle-plus" size="lg" />
                                                Add another item
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-card-body>
                            </b-card>
                            <!-- end items -->
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>

        </b-form>
    </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import PersonalData from "../customer/details_components/PersonalData.vue";


export default {
    name: "GardenHelpCreateQuoteForm",
    components: { PersonalData },
    props: ['job_id', 'perosnal_data_type', "first_name", "last_name",
        "email", "phone_number", "contact_through", "services_list",
        "job_services", "quote_services", "quote_items",
        "products_list", "show_products", "currency"],
    data() {
        return {
            client_name: "GARDENHELP",
            user_type: null,
            user_id: null,


        }
    },

    mounted() {
        // let user = JSON.parse(window.localStorage.getItem("user"));


    },
    methods: {


        clickAddService() {
            this.quote_services.push({
                service_id: null,
                service_name: null,
                invalid_service: false,
                estimated_price: null,
                invalid_estimated_price: false,
                description: null,
                is_orign_service: false
            })
        },
        clickDeleteService(index) {
            this.quote_services.splice(index, 1);
        },
        clickAddProduct() {
            this.quote_items.push({
                name: null,
                invalid_name: false,
                description: null,
                quantity: 1,
                invalid_quantity: false,
                price: null,
                invalid_price: false
            })
        },
        clickDeleteProduct(index) {
            this.quote_items.splice(index, 1)
        },
    }
}

</script>




// WEBPACK FOOTER //
// src/projects/garden_help/quotes/CreateQuoteForm.vue